import { ReactElement, ReactNode } from 'react';
import clsx from 'clsx';

interface FormFieldProps {
  children: ReactNode;
  className?: string;
  infoMessage?: string | null;
  infoMessageAlignment?: 'left' | 'right';
  errorMessage?: string | null;
  errorMessageAlignment?: 'left' | 'right';
}

function FormField({
  children,
  className,
  infoMessage,
  infoMessageAlignment = 'left',
  errorMessage,
  errorMessageAlignment = 'left',
}: FormFieldProps): ReactElement {
  return (
    <div className={className}>
      {children}
      {(infoMessage || errorMessage) && (
        <div className="mt-1">
          {infoMessage && (
            <p
              className={clsx('text-white text-micro', {
                'text-left': infoMessageAlignment === 'left',
                'text-right': infoMessageAlignment === 'right',
              })}
            >
              {infoMessage}
            </p>
          )}

          {errorMessage && (
            <p
              className={clsx('text-red text-micro', {
                'text-left': errorMessageAlignment === 'left',
                'text-right': errorMessageAlignment === 'right',
              })}
            >
              {errorMessage}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default FormField;
